import React from 'react';

export interface IMessageProps {
    message?: undefined | string;
    messageType?: undefined | 'saved' | 'error' | 'general' | 'noData' | 'warning' | 'noDetailsData';
    onClose?: undefined | (() => void);
}

export class DisplayMessage extends React.Component<IMessageProps, Record<string, unknown>> {
    public messageBox: any;

    public override componentDidMount() {
        if (this.props.messageType !== 'saved') {
            window.scrollTo(0, 0);
        }
    }

    public override render() {
        if (!this.props.message) {
            return null;
        }
        const message = this.props.message ?? 'Some went wrong. Please try again.';
        const messageType = this.props.messageType ?? 'unknown type';

        if (!messageType || messageType === 'saved') {
            return (
                <div
                    ref={(ref) => {
                        this.messageBox = ref;
                    }}
                    className="mw800 mauto"
                >
                    <div className="alert alert-micro alert-info .light alert-dismissable">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true" onClick={() => this.close()}>
                            ×
                        </button>
                        <i className="fa fa-info pr10"></i> <strong>{message}</strong>
                    </div>
                </div>
            );
        } else if (messageType === 'error') {
            return (
                <div
                    ref={(ref) => {
                        this.messageBox = ref;
                    }}
                    className="mw800 mauto"
                >
                    <div className="alert alert-sm alert-border-left alert-danger alert-dismissable">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true" onClick={() => this.close()}>
                            ×
                        </button>
                        <i className="fa fa-warning pr10"></i> <strong>{message}</strong>
                    </div>
                </div>
            );
        } else if (messageType === 'general') {
            return (
                <div
                    ref={(ref) => {
                        this.messageBox = ref;
                    }}
                    className="mw800 mauto"
                >
                    <div className="alert alert-sm alert-border-left alert-info alert-dismissable">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true" onClick={() => this.close()}>
                            ×
                        </button>
                        <i className="fa fa-info pr10"></i> <strong>{message}</strong>
                    </div>
                </div>
            );
        } else if (messageType === 'noData' || messageType === 'warning') {
            return (
                <div
                    ref={(ref) => {
                        this.messageBox = ref;
                    }}
                    className="mw800 mauto"
                >
                    <div className="alert alert-sm alert-border-left alert-warning alert-dismissable text-dark">
                        <button type="button" className="close" data-dismiss="alert" aria-hidden="true" onClick={() => this.close()}>
                            ×
                        </button>
                        <i className="fa fa-info pr10"></i> <strong>{message}</strong>
                    </div>
                </div>
            );
        } else if (messageType === 'noDetailsData') {
            return (
                <div className="panel-body p10 bg-light">
                    <div
                        ref={(ref) => {
                            this.messageBox = ref;
                        }}
                        className="mw800 mauto"
                    >
                        <div className="alert alert-sm alert-border-left alert-warning alert-dismissable">
                            <button type="button" className="close" data-dismiss="alert" aria-hidden="true" onClick={() => this.close()}>
                                ×
                            </button>
                            <i className="fa fa-info pr10"></i> <strong>{message}</strong>
                        </div>
                    </div>
                </div>
            );
        }
        return <div>No type defined</div>;
    }

    private close() {
        if (this.props.onClose) {
            this.props.onClose();
        }
    }
}
